module.exports = __webpack_public_path__ + "2da7bd6e0b7c167a3e06ad25bf6b8861.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/692.png
// module id = 1686
// module chunks = 2